// src/utils/visitorTracker.js
import apiService from "../services/ApiService";
import { isPublicPath } from "./publicRoutes";

const VISITOR_KEY_NAME = "dldvax_visitor_key";
const VISIT_SESSION_KEY_NAME = "dldvax_visit_session_key";

// กันการยิงซ้ำเมื่อ React re-render หรือ StrictMode เรียก effect สองรอบ
const DEDUPE_WINDOW_MS = 1500;
let lastTracked = { path: null, at: 0 };

const createKey = () => {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID().replace(/-/g, "");
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
};

const readOrCreateKey = (storage, name) => {
  try {
    let key = storage.getItem(name);
    if (!key) {
      key = createKey();
      storage.setItem(name, key);
    }
    return key;
  } catch (error) {
    // เบราว์เซอร์ที่ปิดการใช้งาน storage จะนับเป็นผู้เข้าชมรายใหม่ทุกครั้ง
    return createKey();
  }
};

export const getVisitorKey = () =>
  readOrCreateKey(window.localStorage, VISITOR_KEY_NAME);

export const getVisitSessionKey = () =>
  readOrCreateKey(window.sessionStorage, VISIT_SESSION_KEY_NAME);

export const getDeviceType = () => {
  const ua = navigator.userAgent || "";
  if (/iPad|Tablet|PlayBook|Silk|Android(?!.*Mobile)/i.test(ua)) return "Tablet";
  if (/Mobile|iPhone|iPod|Android|BlackBerry|IEMobile|Opera Mini/i.test(ua))
    return "Mobile";
  return "Desktop";
};

export const trackPageView = async (pagePath, sessionId = "") => {
  const now = Date.now();
  if (lastTracked.path === pagePath && now - lastTracked.at < DEDUPE_WINDOW_MS) {
    return;
  }
  lastTracked = { path: pagePath, at: now };

  try {
    await apiService({
      method: "POST",
      url: "/trackPageView",
      data: {
        VisitorKey: getVisitorKey(),
        SessionKey: getVisitSessionKey(),
        PagePath: pagePath,
        PageTitle: document.title || "",
        Referrer: document.referrer || "",
        DeviceType: getDeviceType(),
        IsPublicPage: isPublicPath(pagePath),
      },
      sessionId: sessionId || "",
    });
  } catch (error) {
    // การเก็บสถิติต้องไม่กระทบการใช้งานหน้าเว็บ
    console.warn("Track page view failed:", error.message);
  }
};
